// Encrypted VAPI keys for room guide (same scheme as vapi-control-ui).
// Regenerate via plugins/vapi-control-ui `npm run encrypt` and copy publicKey/assistantId here if needed.

const ENCRYPTED_CONFIG = {
  publicKey: '5a62573d-26fd-4126-9c12-e0a37cc53e12',
  privateKey: null,
  assistantId: 'ccc376e3-d0bb-409a-a3d3-004356060adc',
};

export { ENCRYPTED_CONFIG };
export default ENCRYPTED_CONFIG;
